import { Alert, useMantineTheme } from '@mantine/core'
import { Turnstile } from 'components/common/Turnstile'
import { TURNSTILE_KEY } from 'config/env'
import i18next from 'i18next'
import { ErrorOption, useFormContext } from 'react-hook-form'
import type {} from 'react-turnstile'

export const InputCAPTCHA = ({ name }: { name: string }) => {
  const { setValue, setError, formState } = useFormContext()
  const theme = useMantineTheme()
  const language = i18next.language?.toLowerCase().startsWith('pl')
    ? 'pl-pl'
    : 'en-us'
  const error = formState.errors?.[name]

  const onVerify = (token: string) => setValue(name, token)

  const onError = (error: ErrorOption) => setError(name, error)

  if (!TURNSTILE_KEY) return null

  return (
    <div className="w-full flex flex-col gap-1">
      <Turnstile
        sitekey={TURNSTILE_KEY}
        onVerify={onVerify}
        responseFieldName={name}
        onError={onError}
        fixedSize={true}
        language={language}
        theme={theme.colorScheme === 'dark' ? 'dark' : 'light'}
      />
      {!!error?.message && (
        <Alert color="red" mt={16}>
          {error?.message?.toString()}
        </Alert>
      )}
    </div>
  )
}
